import styled from 'styled-components';

import { FontSizes, FontWeights, maxWidth, Text, units } from '@calm-web/design-system';

import StarsIcon from 'icons/five-stars-orange.svg';

export const TestimonialContainer = styled.div<{
	isLeft: boolean;
}>`
	float: ${p => (p.isLeft ? 'left' : 'right')};
	position: relative;
	display: inline-block;
	padding: 42px 36px 28px;
	max-width: 360px;
	min-height: 368px;
	background-color: #fff;
	${maxWidth('desktop')} {
		float: none !important;
		display: block;
		margin: 26px auto 0;
	}
`;

export const StyledText = styled(Text).attrs({
	color: 'offBlack',
	size: FontSizes.lg,
	weight: FontWeights.Light,
	el: 'p',
})`
	line-height: 140%;
	margin-bottom: ${units(4)};
`;

export const Stars = styled(StarsIcon)`
	width: 111px;
	height: 17px;
	position: absolute;
	bottom: 28px;
`;
